import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import MoreVert from '@material-ui/icons/MoreVert';
import TerminalDetails from '../Terminals/TerminalDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { formatLocation } from "../../utils/location";
import withRoot from "../../withRoot";

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  menuIconTableCell: {
    width: 100 + "px"
  },
 menuIconContainer: {
    cursor: "pointer",
    padding: 5 + "px"
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.secondary.light,
    }
  },
  detailsTableCell: {
    padding: "0 !important"
  },
  searchField: {
    fontSize: '0.9rem',
    fontWeight: 'normal',
  },
  searchIcon: {
    fontSize: '0.9rem',
  },
  searchAdornment: {
    marginRight: '0px',
  }
});


class TerminalsTable extends React.Component {
  constructor(props) {
    super(props);
    this.terminalDetailsOpen = {};
    props.terminals.forEach(t => (this.terminalDetailsOpen[t.id] = { open: false }));

    this.state = {
      selectedRow: -1,
      anchorEl: null,
      selectedTerminal: null,
      searchFieldValues: {
        terminalcode: '',
        numberofparts: '',
        location: '',
        status: '',
        comment: ''
      }
    }

  }

  componentDidMount() {
    // Initialize searchfieldvalues from redux state
    this.setState({
      searchFieldValues: {...this.props.searchFieldValues}
    });
  }

  handleClick = (event) => {
    this.handleMenuClose();
    this.setState({ selectedRow: this.state.selectedTerminal.id });
    this.props.handleRowClick(this.state.selectedTerminal);
    this.handleMenuClose();
  }

  handleExpand = (event, terminal) => {
    if (!this.terminalDetailsOpen[terminal.id]) {
      return;
    }
    //  event.stopPropagation();
    this.setState({ selectedRow: terminal.id });
    this.terminalDetailsOpen[terminal.id].open = !this.terminalDetailsOpen[terminal.id].open;
  }

  handleMenuClick = (event, terminal) => {
    this.setState({ anchorEl: event.currentTarget, selectedTerminal: terminal });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null, selectedTerminal: null });
  };

  isOpen = (terminal) => {
    return terminal != null && this.terminalDetailsOpen[terminal.id] != null && this.terminalDetailsOpen[terminal.id].open;
  }

  handleTerminalDelete = (event) => {
    event.stopPropagation();
    this.setState({ selectedRow: this.state.selectedTerminal.id });
    this.props.handleTerminalDelete(this.state.selectedTerminal);
    this.handleMenuClose();
  }

  isSelected = (id) => {
    return this.state.selectedRow === id && this.props.useSelectedRow;
  }

  handleSearchFieldChange = (property) => (event) => {
    this.setState({searchFieldValues: {...this.state.searchFieldValues, [property]: event.target.value}})
    this.props.handleSearchFieldChange({[property]: event.target.value});
  }

  filterTerminalsData = () => {
    let updatedTerminals = this.props.terminals;

    if(this.state.searchFieldValues.terminalcode !== ''){
      updatedTerminals = updatedTerminals.filter( t => {
        const terminalCode = this.state.searchFieldValues.terminalcode;
        return t.terminalCode.toString().slice(0, terminalCode.length).includes(terminalCode);
      })
    }
    if(this.state.searchFieldValues.numberofparts !== ''){
      updatedTerminals = updatedTerminals.filter( t => {
        const numberofparts = this.state.searchFieldValues.numberofparts;
        return t.parts.length === (numberofparts === '' ? 0 : parseInt(numberofparts, 10));
      })
    }
    if(this.state.searchFieldValues.status !== ''){
      updatedTerminals = updatedTerminals.filter( t => {
        const terminalStatus = this.state.searchFieldValues.status;
        return t.status.slice(0, terminalStatus.length).toLowerCase().includes(terminalStatus.toLowerCase());
      })
    }
    if(this.state.searchFieldValues.location !== ''){
      updatedTerminals = updatedTerminals.filter( t => {
        return formatLocation(t.location).toLowerCase().search(this.state.searchFieldValues.location.toLowerCase()) !== -1;
      })
    }
    if(this.state.searchFieldValues.comment !== ''){
      updatedTerminals = updatedTerminals.filter( t => {
        return t.comment.toLowerCase().search(this.state.searchFieldValues.comment.toLowerCase()) !== -1;
      })
    }

    return updatedTerminals;
  }

  render() {
    const { classes, role } = this.props;
    const { anchorEl } = this.state;

    const showTerminals = this.filterTerminalsData();
    return (
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>

            <TableRow>
              <TableCell></TableCell>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Terminal Code</Grid>
                  <Grid item>
                    <Input
                      id='terminalsterminalcode'
                      className={classes.searchField}
                      type='text'
                      value={this.state.searchFieldValues.terminalcode}
                      onChange={this.handleSearchFieldChange('terminalcode')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Number of parts</Grid>
                  <Grid item>
                    <Input
                      id='terminalsnumberofparts'
                      className={classes.searchField}
                      type='text'
                      value={this.state.searchFieldValues.numberofparts}
                      onChange={this.handleSearchFieldChange('numberofparts')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Status</Grid>
                  <Grid item>
                    <Input
                      id='terminalsstatus'
                      className={classes.searchField}
                      type='text'
                      value={this.state.searchFieldValues.status}
                      onChange={this.handleSearchFieldChange('status')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Location</Grid>
                  <Grid item>
                    <Input
                      id='terminalslocation'
                      className={classes.searchField}
                      value={this.state.searchFieldValues.location}
                      onChange={this.handleSearchFieldChange('location')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Comment</Grid>
                  <Grid item>
                    <Input
                      id='terminalscomment'
                      className={classes.searchField}
                      value={this.state.searchFieldValues.comment}
                      onChange={this.handleSearchFieldChange('comment')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              {role === "admin" && <TableCell className={classes.menuIconTableCell}></TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {showTerminals.map(t => {
              const isSelected = this.isSelected(t.id);
              return (
                <React.Fragment key={t.id}>
                  <TableRow className={classes.row} selected={isSelected}>
                    <TableCell>
                      {t.parts && t.parts.length > 0 && <span onClick={event => this.handleExpand(event, t)}>
                       { this.isOpen(t) && <ExpandLessIcon className={classes.icon} /> }
                       { !this.isOpen(t) && <ExpandMoreIcon className={classes.icon} /> }
                        </span>}
                      </TableCell>
                      <TableCell>{t.terminalCode}</TableCell>
                      <TableCell>{t.parts != null ? t.parts.length : ""}</TableCell>
                      <TableCell>{t.status}</TableCell>
                    <TableCell>{formatLocation(t.location)}</TableCell>
                    <TableCell>{t.comment}</TableCell>
                    {role === "admin" && <TableCell className={classes.menuIconTableCell}>
                      <span onClick={event => this.handleMenuClick(event, t)} className={classes.menuIconContainer}><MoreVert className={classes.icon} /></span>
                    </TableCell>}
                  </TableRow>
                  {this.isOpen(t) && <TableRow>
                    <TableCell className={classes.detailsTableCell} colSpan="7">
                      <TerminalDetails terminal={t} />
                    </TableCell>
                  </TableRow>}
                </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
        {role === "admin" && <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleMenuClose}
        >
        <MenuItem onClick={event => this.handleClick(event)}>Edit</MenuItem>
        <MenuItem onClick={event => this.handleTerminalDelete(event)}>Delete</MenuItem>
      </Menu>}
      </Paper>
    );
  }
}

TerminalsTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRoot(withStyles(styles)(TerminalsTable));



// WEBPACK FOOTER //
// ./src/components/Tables/TerminalsTable.js